import MarginOptions from './MarginOptions'
import { TextAlignmentOptions } from './TypographyOptions'
import { RightBarEditorProps } from './BulletPointsEditor'
import { ButtonData } from '@bm-js/atlascloud-shared'
import RightBarGroup from './RightBarGroup'
import Select from './Select'
import Input from './Input'
import { useTr } from '../utils/useTr'
import { TrKey } from '../cnst/translations/trKey.cnst'

const ButtonEditor = ({
  setData,
  content,
}: RightBarEditorProps<ButtonData>) => {
  const { tr } = useTr()
  return (
    <>
      <Input
        light
        label={tr(TrKey.buttonEditorButtonTextLabel)}
        placeholder={tr(TrKey.buttonEditorButtonTextPlaceholder)}
        type='text'
        name='buttonText'
        id='buttonText'
        value={content.data.buttonText}
        onChange={setData}
      />
      <Input
        light
        label={tr(TrKey.buttonEditorButtonLinkLabel)}
        desc={tr(TrKey.buttonEditorButtonLinkDescription)}
        placeholder={tr(TrKey.buttonEditorButtonLinkPlaceholder)}
        type='text'
        name='link'
        id='link'
        value={content.data.link}
        onChange={setData}
      />

      <RightBarGroup title={tr(TrKey.buttonEditorButtonSettingsTitle)} topLine>
        <Select
          light
          label={tr(TrKey.buttonEditorColorLabel)}
          desc={tr(TrKey.buttonEditorColorDescription)}
          name='btnColor'
          id='btnColor'
          value={content.data.btnColor}
          onChange={setData}
        >
          <option value='customer'>
            {tr(TrKey.buttonEditorColorOptionCustomer)}
          </option>
          <option value='accent'>
            {tr(TrKey.buttonEditorColorOptionAccent)}
          </option>
          <option value='dark'>{tr(TrKey.buttonEditorColorOptionDark)}</option>
          <option value='light'>
            {tr(TrKey.buttonEditorColorOptionLight)}
          </option>
        </Select>
        <Select
          light
          label={tr(TrKey.buttonEditorTypeLabel)}
          desc={tr(TrKey.buttonEditorTypeDescription)}
          name='btnType'
          id='btnType'
          value={content.data.btnType}
          onChange={setData}
        >
          <option value='filled'>
            {tr(TrKey.buttonEditorTypeOptionFilled)}
          </option>
          <option value='outline'>
            {tr(TrKey.buttonEditorTypeOptionOutline)}
          </option>
        </Select>
        <TextAlignmentOptions content={content} setData={setData} />
      </RightBarGroup>

      <MarginOptions setData={setData} content={content} />
    </>
  )
}

export default ButtonEditor
